import React from 'react'
import CellContent from './CellContent'
import useOfferMetaData from 'hooks/Offers/useOfferMetaData'
import { useBedbankRoomRatePromotions } from 'hooks/OfferPage/useBedbankPromotions'
import BedbankLTSSearchTileFeatures from 'components/SearchKit/SearchTiles/accommodations/BedbankLTSSearchTileFeatures'
import BedbankSearchTileFeatures from 'components/SearchKit/SearchTiles/accommodations/BedbankSearchTileFeatures'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  filters: App.OfferListFilters
}

function BedbankHotelSearchInclusionsCell({
  filters,
  offer,
}: Props) {
  const offerMetaData = useOfferMetaData(offer.id, filters)
  const isAnytimeSearch = (!filters?.checkIn && !filters?.checkOut) && !filters?.flexibleNights
  const promotions = useBedbankRoomRatePromotions(offer.promotions, filters?.checkIn, filters?.checkOut, isAnytimeSearch)
  const isLTSOffer = offerMetaData?.hasPromotions || !!Object.values(promotions).length

  return <CellContent>
    {!isLTSOffer && <BedbankSearchTileFeatures offer={offer} filters={filters} truncateAfter={50} singleColumn />}
    {isLTSOffer && <BedbankLTSSearchTileFeatures offer={offer} truncateAfter={50} />}
  </CellContent>
}

export default BedbankHotelSearchInclusionsCell
